
// import { faClose } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import React, { useState, useEffect } from "react";

// const Drawer = ({
//   children,
//   position,
//   drawerOpen,
//   setDrawerOpen,
//   onClose,
//   onCloseBool,
//   shouldCloseDrawer,
// }) => {
//   const [closingProgrammatically, setClosingProgrammatically] = useState(false);

//   // Drawer styles
//   const drawerStyle = {
//     position: "fixed",
//     top: "0",
//     left: drawerOpen ? "0" : position === "right" ? "100%" : "-100%",
//     minHeight: "100vh",
//     width: "100%",
//     backgroundColor: "rgba(100, 100, 100, 0.5)",
//     zIndex: "1000",
//     display: "flex",
//     flexDirection: "column",
//   };

//   const contentStyle = {
//     width: "50%",
//     padding: ".5rem",
//     backgroundColor: "white",
//     minHeight: "inherit",
//     overflowY: "scroll",
//     position: "relative",
//     marginLeft: position === "right" ? "auto" : "unset",
//     marginRight: position === "left" ? "auto" : "unset",
//     transition: "transform 0.3s ease",
//     transform: drawerOpen
//       ? "translateX(0)"
//       : `translateX(${position === "right" ? "100%" : "-100%"})`,
//     flexGrow: 1,
//     display: "flex",
//     flexDirection: "column",
//   };

//   // Effect to handle programmatic closing
//   useEffect(() => {
//     if (!drawerOpen) {
//       handleClose();
//     }
//     // Reset the flag after calling onClose
//   }, [drawerOpen]);

//   // Handle drawer close actions
//   const handleClose = () => {
//     if (onCloseBool && shouldCloseDrawer) 
//     {
//       onClose();
//       setDrawerOpen(false);
//     }
//   };

//   return (
//     <div
//       className="Drawer"
//       style={drawerStyle}
//       onKeyDown={(e) => {
//         console.log("key down")
//         if(e?.key === "Escape") handleClose();

//       }}
//       tabIndex={0}
//       onMouseDown={(e) => {
//         if (e.target === e.currentTarget) {
//           handleClose();
//         }
//       }}
//     >
//       <div className="DrawerContent" style={contentStyle}>
//         <button
//           onClick={() => {
//             handleClose();
//           }}
//           style={{
//             position: "absolute",
//             left: "1rem",
//             top: "1rem",
//             width: "2rem",
//           }}
//           className="btnCancel"
//         >
//           <FontAwesomeIcon icon={faClose}></FontAwesomeIcon>
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// };

// export default Drawer;

//--------------------------------------2-----------------------------------------------------------

import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";

const Drawer = ({
  children,
  position, // "left", "right", "bottom"
  drawerOpen,
  setDrawerOpen,
  onClose,
  onCloseBool,
  shouldCloseDrawer,
}) => {
  const [closingProgrammatically, setClosingProgrammatically] = useState(false);

  // Drawer styles
  const drawerStyle = {
    position: "fixed",
    top: position === "bottom" ? "unset" : "0",
    bottom: position === "bottom" ? (drawerOpen ? "0" : "-100%") : "unset",
    left: position === "right" ? "unset" : "0",
    right: position === "right" ? (drawerOpen ? "0" : "-100%") : "unset",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "rgba(100, 100, 100, 0.5)",
    zIndex: "1000",
    display: "flex",
    flexDirection: "column",
    // transition: "bottom 0.3s ease, right 0.3s ease", // Add transition for smooth effect
  };

  const contentStyle = {
    width: position === "bottom" ? "100%" : "38%",
    // padding: ".5rem",
    // backgroundColor: "white",
    minHeight: "inherit",
    // overflowY: "scroll",
    position: "relative",
    marginLeft: position === "right" ? "auto" : "unset",
    marginRight: position === "left" ? "auto" : "unset",
    transition: "transform 0.3s ease",
    transform: drawerOpen
      ? position === "bottom"
        ? "translateY(0)"
        : "translateX(0)"
      : position === "bottom"
      ? "translateY(100%)"
      : `translateX(${position === "right" ? "100%" : "-100%"})`,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  };

  // Effect to handle programmatic closing
  useEffect(() => {
    if (!drawerOpen) {
      handleClose();
    }
  }, [drawerOpen]);

  // Handle drawer close actions
  const handleClose = () => {
    if (onCloseBool && shouldCloseDrawer) {
      onClose();
      setDrawerOpen(false);
    }
  };

  return (
    <div
      className="Drawer"
      style={drawerStyle}
      onKeyDown={(e) => {
        if (e?.key === "Escape") handleClose();
      }}
      tabIndex={0}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          handleClose();
        }
      }}
    >
      <div className="DrawerContent" style={contentStyle}>
        <button
          onClick={() => {
            handleClose();
          }}
          style={{
            position: "absolute",
            left: "1rem",
            top: "1rem",
            width: "2rem",
          }}
          className="btnCancel"
        >
          <FontAwesomeIcon icon={faClose}></FontAwesomeIcon>
        </button>
        {children}
      </div>
    </div>
  );
};

export default Drawer;
